import React, { useEffect, useCallback, useState } from 'react';
import maintenancePage from '@images/maintenance-page.svg';
import { Session } from '@models/session.model';
import SessionService from '@services/session.service';
import { Icon, useTranslation } from '@testsigma/atoms';

const useNavigateHome = () =>
  useCallback(() => {
    window.location.href = window.location.origin;
  }, []);

const UnderMaintenanceComponent: React.FC = () => {
  const { t } = useTranslation();
  const navigateHome = useNavigateHome();
  const [loading, setLoading] = useState(true);

  // Fetch session data and handle redirection or error
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const res = await SessionService.show();
        if (res instanceof Session && res.user) {
          navigateHome();
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSession();
  }, [navigateHome]);

  if (loading) {
    return (
      <div className='flex justify-center items-center h-full'>
        <p>{t('common.loading')}</p>
      </div>
    );
  }

  return (
    <div className='flex flex-col h-[90%] items-center'>
      <img
        src={maintenancePage}
        alt='Maintenance Page'
        className='w-1/2 h-[500px]'
      />
      <h1 className='text-[20px] font-medium pb-2'>
        {t('common.under.maintenance.title')}
      </h1>
      <p className='text-[14px] text-secondary-500 text-center max-w-[600px]'>
        {t('common.under.maintenance.message')}
      </p>
      <div className='mt-[30px] flex items-center gap-x-1'>
        <Icon name='refresh' className='text-primary-600' />
        <span
          className='truncate w-full pr-2.5 text-primary-600 cursor-pointer text-sm'
          onClick={navigateHome}
        >
          {t('refresh.now')}
        </span>
      </div>
      <div className='items-center rounded-b-lg text-center h-[10%]'>
        <span
          className='text-small text-secondary-700 font-normal'
          dangerouslySetInnerHTML={{
            __html: t('common.under.maintenance.support'),
          }}
        ></span>
      </div>
    </div>
  );
};

export default UnderMaintenanceComponent;
